import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {NoteDataModel} from "../../../../../../models/notes/note-data.model";

export interface NoteDialogData {
  note: NoteDataModel;
  isLocked: boolean;
}

@Component({
  standalone: false,
  selector: 'app-note-dialog',
  templateUrl: './note-dialog.component.html',
  styleUrls: ['./note-dialog.component.scss']
})
export class NoteDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<NoteDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: NoteDialogData) { }

  ngOnInit(): void {
  }

  onOkClick() {
    this.dialogRef.close(this.data.note);
  }
}
